export * from './src/promote-marketing-v2-ads-txt-ads-txt.schemas.js';
